module.exports = "<footer>\n\t<p class=\"text-center\">Version: 1.9.5</p>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// /root/anvel/angular/app/components/defaults/footer/footer.component.html
// module id = ../../../../../angular/app/components/defaults/footer/footer.component.html
// module chunks = 1